import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { LeakDetectionStatus } from '@app/core/enums/leak-detection-status.enum';

@Component({
  selector: 'gc-ld-logger-noise-leak-score-gauge',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ld-logger-noise-leak-score-gauge.component.html',
  host: {
    class: 'flex items-center justify-center shrink-0',
  },
})
export class LdLoggerNoiseLeakScoreGaugeComponent {
  public status = input.required<LeakDetectionStatus | undefined>();
  public width = input<number>(36);

  protected readonly defaultColor = 'var(--p-other-opacity-gray-100-50)';

  public height = computed(() => (this.width() * 13) / 36);

  public leakState = computed(() => {
    switch (this.status()) {
      case LeakDetectionStatus.Critical:
        return { color: 'var(--p-other-red-500)', level: 3 };
      case LeakDetectionStatus.Warn:
        return { color: 'var(--p-orange-500)', level: 2 };
      case LeakDetectionStatus.Normal:
        return { color: 'var(--p-other-green-500)', level: 1 };
      default:
        return { color: this.defaultColor, level: 0 };
    }
  });
}
